var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardimage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 283,
    viewBox: "0 0 282 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_438_888)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0.875,
    width: 274,
    height: 274,
    rx: 30,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.184 198.289H114.223C114.223 193.322 118.249 189.295 123.216 189.295H159.191C164.158 189.295 168.184 193.322 168.184 198.289Z",
    fill: "#E8EDEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.942 189.295H125.465L129.962 171.308H152.446L156.942 189.295Z",
    fill: "#B0B6BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.408 153.321H76V84.7445C76 80.3983 79.5233 76.875 83.8695 76.875H198.538C202.885 76.875 206.408 80.3983 206.408 84.7445L206.408 153.321Z",
    fill: "#38454F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.538 171.308H83.8695C79.5233 171.308 76 167.785 76 163.439V153.321H206.408V163.439C206.408 167.785 202.884 171.308 198.538 171.308Z",
    fill: "#E8EDEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.459 101.608H147.95V88.1172H134.459V101.608Z",
    fill: "#ECBA16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.955 124.091H143.452V101.607H138.955V124.091Z",
    fill: "#25AE88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M177.177 125.72H172.681V117.347H109.725V125.72H105.229V112.85H177.177V125.72Z",
    fill: "#25AE88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.471 133.085C116.471 138.052 112.445 142.079 107.478 142.079C102.511 142.079 98.4844 138.052 98.4844 133.085C98.4844 128.119 102.511 124.092 107.478 124.092C112.445 124.092 116.471 128.119 116.471 133.085Z",
    fill: "#ECBA16"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.198 133.085C150.198 138.052 146.171 142.079 141.204 142.079C136.238 142.079 132.211 138.052 132.211 133.085C132.211 128.119 136.238 124.092 141.204 124.092C146.171 124.092 150.198 128.119 150.198 133.085Z",
    fill: "#ECBA16"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M183.923 133.085C183.923 138.052 179.896 142.079 174.929 142.079C169.962 142.079 165.936 138.052 165.936 133.085C165.936 128.119 169.962 124.092 174.929 124.092C179.896 124.092 183.923 128.119 183.923 133.085Z",
    fill: "#ECBA16"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_438_888",
    x: -19,
    y: -18.125,
    width: 318,
    height: 318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_438_888"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_438_888",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -23,
    dy: -19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_438_888"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 21,
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_438_888",
    result: "effect3_innerShadow_438_888"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardimage1);
export default __webpack_public_path__ + "static/media/cardimage1.a382f4e562a0fba77a1c69ea489910fb.svg";
export { ForwardRef as ReactComponent };